/* eslint-disable @typescript-eslint/no-var-requires */
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
} from 'react';

import './animation034.less';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation034Item {
  color: string;
  text: string;
}

interface IAnimation034Props {
  items: IAnimation034Item[];
  className?: string | null;
  onCompleted: () => void;
}

const Animation034: FunctionComponent<IAnimation034Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation034 onCompleted');
      onCompleted && onCompleted();
    }
  };

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };
  return (
    <div ref={crrRef} className={`animation034 component ${className}`}>
      <div className="animation034-content">
        {items.map((itm: IAnimation034Item, idx: number) => (
          <div
            key={idx}
            className={`animation034-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <img
              className="click-point"
              onClick={() => clickToPlay()}
              style={{
                display: play <= 1 ? 'block' : 'none',
              }}
              src={ImgPoint}
              alt=""
            />
            <div
              className="animation034-indicate-number"
              style={{ borderColor: itm.color }}
            >
              <div className="number" style={{ color: itm.color }}>
                0{idx + 1}
              </div>
            </div>
            <div
              className="animation034-body"
              style={{ backgroundColor: itm.color }}
            >
              <div
                className="animation034-text"
                dangerouslySetInnerHTML={{ __html: itm.text }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation034;
